import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from '@angular/router';
import { TranslateModule } from "@ngx-translate/core";
import { RfqModalComponent } from "./rfq-modal";
import { MatDialogModule } from '@angular/material/dialog';
import {ContentloaderModule} from "@signature-it/ngx-generic/components/contentloader";
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {NgxMatSelectSearchModule} from '@signature-it/ngx-generic/node_modules/ngx-mat-select-search';
import {SearchPipeModule} from '@signature-it/ngx-generic/pipes';
import {SpinElDirectiveModule} from '@signature-it/ngx-generic/directives';
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        RouterModule,
        MatDialogModule,
        ContentloaderModule,
        FormsModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        ReactiveFormsModule,
        SpinElDirectiveModule,
        NgxMatSelectSearchModule,
        SearchPipeModule,
        MatCheckboxModule
    ],
    exports: [RfqModalComponent],
    declarations: [RfqModalComponent]
})
export class RfqModalModule {}
